module.exports = __webpack_public_path__ + "img/one.02173add.png";